











































import Vue, { PropType } from 'vue'
export default Vue.extend({
  name: 'CpButton',
  inheritAttrs: false,
  props: {
    variant: {
      type: String as PropType<'primary' | 'secondary'>,
      default: 'primary',
    },
    tagName: {
      type: String as PropType<'button' | 'a'>,
      default: 'button',
    },
    href: {
      type: String,
      default: '',
    },
  },
  computed: {
    tag(): string {
      if (this.href && this.tagName !== 'a') {
        throw new Error(
          'href属性を利用する場合はtagNameに"a"を指定してください'
        )
      }
      return this.tagName
    },
  },
})
